import { render, staticRenderFns } from "./auction-services.vue?vue&type=template&id=b9f64c46&"
import script from "./auction-services.vue?vue&type=script&lang=js&"
export * from "./auction-services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports